import React from 'react';
import logo from '../../../assets/SchoolLink-logo-web.png';

interface PasswordResetFormProps {
  email: string;
  error: string | null;
  isLoading: boolean;
  onEmailChange: (email: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}

const PasswordResetForm: React.FC<PasswordResetFormProps> = ({
  email,
  error,
  isLoading,
  onEmailChange,
  onSubmit,
  onCancel
}) => {
  return (
    <form method="post" onSubmit={onSubmit}>
      <div className="text-center pb-4">
        <img style={{ width: "70%" }} src={logo} className="rounded" alt="SchoolLink Logo" />
      </div>
      
      <div className="form-group">
        <label htmlFor="resetEmail">Email*</label>
        <input
          type="email"
          id="resetEmail"
          className="form-control"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          disabled={isLoading}
          required
        />
        {error && (
          <span className="alert alert-danger" style={{ color: "#f00", fontSize: '14px' }}>
            {error}
          </span>
        )}
      </div>
      
      <div className="col-12">
        <button
          type="button"
          style={{ marginTop: "7px" }}
          className="pull-left btn btn-outline-danger btn-lg btn-block"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="submit"
          style={{ marginTop: "7px" }}
          className="pull-right bg-gradient-theme-left border-0 btn btn-primary btn-lg btn-block"
          disabled={isLoading}
        >
          {isLoading ? 'Sending...' : 'Reset Password'}
        </button>
      </div>
    </form>
  );
};

export default PasswordResetForm;
